import { ApolloProvider } from "@apollo/client";
import React from "react";
import App from "./App";
import { contentfulClient } from "./apollo";

// The app with its providers, as the browser runs it. src/index.tsx mounts it,
// and the integration tests render it, so both use the same tree.
export const Root = () => (
  <React.StrictMode>
    <ApolloProvider client={contentfulClient}>
      <App />
    </ApolloProvider>
  </React.StrictMode>
);
